import React from 'react';
import { ExcelImportModalView } from './ExcelImportModalView';
import { useExcelImport } from './useExcelImport';

type ExcelImportModalProps = {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
};

/**
 * The "Excel import" modal: drop / select a filled purchase template, watch
 * the analyzing stage, then get carried to /purchases/file-import. Container
 * wires {@link useExcelImport} into the render-only `ExcelImportModalView`.
 */
export const ExcelImportModal: React.FC<ExcelImportModalProps> = ({
    isOpen,
    onOpenChange,
}) => {
    const { stage, onDrop, onFilesPicked, onTryAgain } = useExcelImport({
        isOpen,
        onOpenChange,
    });

    return (
        <ExcelImportModalView
            isOpen={isOpen}
            onDrop={onDrop}
            onFilesPicked={onFilesPicked}
            onOpenChange={onOpenChange}
            onTryAgain={onTryAgain}
            stage={stage}
        />
    );
};
